import PictureLazy from '@maison/components/common/PictureLazy';

export default {
  components: {
    PictureLazy,
  },

  props: {
    id: {
      type: [String, Number],
      default: '',
    },
    url: {
      type: String,
      required: true,
    },
    image: {
      type: Object,
      required: true,
    },
    collection: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    vatInformation: {
      type: String,
      required: false,
    },
    shouldDisplayAddToWishlist: {
      type: Boolean,
      default: false,
    },
    shouldDisplayRemoveFromCart: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    onRemove: {
      type: Function,
      default: () => ({}),
    },
    dataCyRemoveButton: {
      type: String,
      default: 'cart-summary-remove-btn',
    },
    openLinkInNewWindow: {
      type: Boolean,
      default: false,
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
    tracking: {
      type: Object,
      default: null,
    },
  },
};
